import { createItemByIdOnceHook } from 'modules/utils/helpers/createItemByIdOnceHook'
import { createItemListOnceHook } from 'modules/utils/helpers/createItemListOnceHook'
import actions from './duck'
import selectors from './selectors'

export const usePedigreedTargetSkuList = createItemListOnceHook(selectors, actions.listRequested)
export const usePedigreedTargetSkuByIdOnce = createItemByIdOnceHook(selectors, actions.itemRequested)
